'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _NavigationBarControl = require('../../../lib/ui/NavigationBarControl');

var _NavigationBarControl2 = _interopRequireDefault(_NavigationBarControl);

var _IndexControl = require('../../../lib/ui/IndexControl');

var _IndexControl2 = _interopRequireDefault(_IndexControl);

var _PositionForm = require('../ui/PositionForm');

var _PositionForm2 = _interopRequireDefault(_PositionForm);

var _PositionModel = require('../model/PositionModel');

var _PositionModel2 = _interopRequireDefault(_PositionModel);

var _LogentryModel = require('../../logentry/model/LogentryModel');

var _LogentryModel2 = _interopRequireDefault(_LogentryModel);

var _ObjectTypeMapping = require('../../constants/ObjectTypeMapping');

var _ObjectTypeMapping2 = _interopRequireDefault(_ObjectTypeMapping);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var EditPosition = function EditPosition(element, args) {
  var _this = this;

  _classCallCheck(this, EditPosition);

  this.onchange = function () {
    _this.data = _this.positionForm.getValue();
    window.PRIM.initDelayedNavigation();
    window.PRIM.dataAccess.put('positions', _this.data.getJSON()).then(function (position) {
      if (!window.PRIM.isDelayedNavigationActive()) {
        return;
      }

      if (args && !args.id && position.id) {
        window.PRIM.navigate('/positions/' + position.id, true);
      }

      if (position) {
        _this.data.values.id = position.id;
        _this.positionForm.setValue(_this.data);
      }
    });
  };

  if (args) {
    if (args.id) {
      window.PRIM.dataAccess.resolve('positions', args.id, true).then(function (position) {
        _this.data = position;

        window.PRIM.dataAccess.get('logentries').then(function (logentries) {
          var results = logentries.filter(function (logentry) {
            return logentry.target_id === _this.data.values.id && logentry.object_type_id === _ObjectTypeMapping2.default.position;
          });

          _this.data.logentries = results.map(function (logentry) {
            return new _LogentryModel2.default(logentry);
          });

          _this.logIndex.setItems(_this.data.logentries);
          _this.positionForm.setValue(_this.data);
        }, function () {
          _this.positionForm.setValue(_this.data);
        }).catch(function () {});
      }, function () {
        if (confirm('Deze functie bestaat niet, mogelijk is deze intussen verwijderd. Wilt u een nieuwe functie aanmaken?')) {
          window.PRIM.navigate('/positions/');
        } else {
          history.back();
        }
      }).catch(function () {});
    } else if (args.person_id) {
      window.PRIM.dataAccess.resolve('people', args.person_id, true).then(function (person) {
        _this.data = new _PositionModel2.default();
        _this.data.values.person_id = person.values.id;
        _this.data.person = person;
        _this.positionForm.setValue(_this.data);
      });
    } else if (args.location_id) {
      window.PRIM.dataAccess.resolve('locations', args.location_id, true).then(function (location) {
        _this.data = new _PositionModel2.default();
        _this.data.values.location_id = location.values.id;
        _this.data.location = location;
        _this.positionForm.setValue(_this.data);
      });
    }
  }

  this.data = new _PositionModel2.default();

  var fragment = document.createDocumentFragment();
  new _NavigationBarControl2.default(fragment, {
    title: 'Functie bewerken',
    leftHandButtons: [{
      onclick: function onclick() {
        history.back();
      },
      icon: '\uE00D'
    }, {
      onclick: function onclick() {
        history.forward();
      },
      icon: '\uE01A'
    }, {
      onclick: function onclick() {
        window.PRIM.navigate('/start/');
      },
      icon: '\uE08A'
    }, {
      onclick: this.onchange,
      icon: '\uE020',
      classes: 'indicator'
    }],
    contextMenu: [{
      onclick: function onclick() {
        if (_this.data.values.id) {
          window.PRIM.navigate('/logentries/position/' + _this.data.values.id);
        } else {
          alert('Vul eerst gegevens voor deze functie.');
        }
      },
      icon: '\uE032',
      label: 'Logboekregel'
    }, {
      onclick: function onclick() {
        if (_this.data.values.id) {
          if (confirm('Weet u het zeker dat u deze functie wilt verwijderen?')) {
            window.PRIM.dataAccess.delete('positions', _this.data.values.id).then(function () {
              history.back();
            });
          }
        } else {
          alert('Vul eerst gegevens voor deze functie.');
        }
      },
      icon: '\uE123',
      label: 'Verwijderen'
    }]
  });

  var div = document.createElement('div');
  div.className = 'viewport';

  var divContent = document.createElement('div');
  divContent.className = 'content';

  var primaryData = document.createElement('section');
  primaryData.className = 'primary';
  var secondaryData = document.createElement('section');
  secondaryData.className = 'secondary';

  this.positionForm = new _PositionForm2.default(primaryData, { position: this.data, onchange: this.onchange });

  var fieldsetLog = document.createElement('fieldset');
  var legendLog = document.createElement('legend');
  legendLog.innerHTML = 'Logboek';
  fieldsetLog.appendChild(legendLog);

  var onclickLogentry = function onclickLogentry(item) {
    window.PRIM.navigate('/logentries/' + item.values.id);
    return;
  };

  this.logIndex = new _IndexControl2.default(fieldsetLog, { items: this.data.logentries, reverse: true, showImage: false, onclick: onclickLogentry });

  secondaryData.appendChild(fieldsetLog);

  divContent.appendChild(primaryData);
  divContent.appendChild(secondaryData);
  div.appendChild(divContent);
  fragment.appendChild(div);

  element.appendChild(fragment);
};

exports.default = EditPosition;


//////////////////
// WEBPACK FOOTER
// ./js/modules/position/action/EditPosition.js
// module id = 52
// module chunks = 0